import { Carousel } from "antd";
import TicketCheckCard from "../ticketCheckCard";
import { useState } from "react";
import { useGetProgramBookingTicketCheckWebByProgramBookingId } from "./model";
import { useMyContext } from "../../../../../../../entities/context";

interface IProps {
    programBookingId: number
}

const TicketCheckCarousel = ({ programBookingId }: IProps) => {
    const [carouselIdx, setCarouselIdx] = useState<number>(0)
    const { data } = useGetProgramBookingTicketCheckWebByProgramBookingId<IProgramBookingTicketCheckWebResponse>(programBookingId)
    const { topHeight } = useMyContext();

    return <>
        <div className="ticket-check-carousel" style={{ marginTop: topHeight }}>
            {(data?.ticketCheckResponseList?.length ?? 0) > 1 && data?.programIsPaid !== false
                ? <>
                    <Carousel beforeChange={q => setCarouselIdx(q)} style={{ width: '100%' }} draggable autoplay autoplaySpeed={5000} dots={false} >
                        {data?.ticketCheckResponseList.map((q, idx) =>
                            <TicketCheckCard
                                key={idx}
                                data={{
                                    programTitle: data.programTitle,
                                    programIsPaid: data.programIsPaid,
                                    qrcodeImgUrl: data.qrcodeImgUrl,
                                    ticketName: q.ticketName,
                                    memberName: data.memberName,
                                    targetDateTime: data.targetDateTime,
                                    ticketTotalCount: data?.ticketCheckResponseList.length
                                }} />)}
                    </Carousel>

                    <div className="costom-dots" style={{ display: 'flex', justifyContent: 'center', gap: '4px', marginTop: '34px' }}>
                        {data?.ticketCheckResponseList.map((_, idx) => <div key={idx} style={{ width: '6px', height: '6px', borderRadius: '100%', backgroundColor: carouselIdx === idx ? 'var(--basewhite)' : 'var(--dimd100)' }} />)}
                    </div>
                </>
                : data &&
                <TicketCheckCard
                    key={programBookingId}
                    data={{
                        programTitle: data.programTitle,
                        programIsPaid: data.programIsPaid,
                        qrcodeImgUrl: data.qrcodeImgUrl,
                        ticketName: data?.ticketCheckResponseList?.[0].ticketName,
                        memberName: data.memberName,
                        targetDateTime: data.targetDateTime,
                        ticketTotalCount: data?.ticketCheckResponseList.length
                    }} style={{ margin: '0 auto' }} />}
        </div>
    </>
}
export default TicketCheckCarousel;